require('./manageOrganizationFormViewer.tpl.html');

/*@ngInject*/
const ManageOrganizationFormViewerController = function ($scope, $stateParams) {

    $scope.viewModel = {
        formId: parseInt($stateParams.formId)
    };
};

angular.module('ums.configuration')
    .controller('manageOrganizationFormViewerController', ManageOrganizationFormViewerController);
